export default __webpack_public_path__ + "static/media/cohortone.08f3c549.png";